import React from "react";

import { Button } from "@xometry/xometry_loft";

const RefreshButton = () => (
  <Button kind="primary" size="large" onClick={() => window.location.reload()}>
    Back to previous page
  </Button>
);

export default RefreshButton;
